import { useAuthActions } from '@core-frontend/core-frontend';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from '@/app/app-router';

import { useMutate } from '@/shared/model/hooks';

import { resetPasswordAsync } from '../api';

export const useResetPasswordMutation = () => {
  const navigate = useNavigate();
  const { setUserEmail } = useAuthActions();
  return useMutate(resetPasswordAsync, {
    onMutate: ({ email }) => {
      setUserEmail(email);
    },
    onSuccess: () => {
      navigate(AppRoutes.CHECK_YOUR_EMAIL_RESET_PASSWORD);
    },
  });
};
